export default "__VITE_ASSET__981TmZFE__"